import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from '../../../utils/shallow-equal';
import nouislider from 'nouislider';

export default class Nouislider extends Component {
  static propTypes = {
    // http://refreshless.com/nouislider/slider-options/#section-animate
    animate: PropTypes.bool,
    // http://refreshless.com/nouislider/slider-options/#section-Connect
    connect: PropTypes.oneOfType([
      PropTypes.oneOf(['lower', 'upper']),
      PropTypes.bool
    ]),
    // http://refreshless.com/nouislider/slider-options/#section-cssPrefix
    cssPrefix: PropTypes.string,
    // Use instead of `start`, for uncontrolled component
    defaultStart: PropTypes.arrayOf(PropTypes.number),
    // http://refreshless.com/nouislider/slider-options/#section-orientation
    direction: PropTypes.oneOf(['ltr', 'rtl']),
    // https://refreshless.com/nouislider/more/#section-disable
    disabled: PropTypes.bool,
    // http://refreshless.com/nouislider/slider-options/#section-limit
    limit: PropTypes.number,
    // http://refreshless.com/nouislider/slider-options/#section-margin
    margin: PropTypes.number,
    // http://refreshless.com/nouislider/events-callbacks/#section-change
    onChange: PropTypes.func,
    // http://refreshless.com/nouislider/events-callbacks/#section-update
    onSlide: PropTypes.func,
    // http://refreshless.com/nouislider/events-callbacks/#section-slide
    onUpdate: PropTypes.func,
    // http://refreshless.com/nouislider/slider-options/#section-orientation
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    // http://refreshless.com/nouislider/pips/
    pips: PropTypes.object,
    // http://refreshless.com/nouislider/slider-values/#section-range
    range: PropTypes.object.isRequired,
    // http://refreshless.com/nouislider/slider-options/#section-start
    start: PropTypes.arrayOf(PropTypes.number),
    // http://refreshless.com/nouislider/slider-options/#section-step
    step: PropTypes.number,
    // http://refreshless.com/nouislider/slider-options/#section-tooltips
    tooltips: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
  };

  componentDidMount() {
    this.createSlider();
  }

  shouldComponentUpdate(nextProps) {
    let shouldUpdate = false;

    function arraysEqual(arr1, arr2) {
      if (arr1 !== arr2) {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
          return false;
        }
        if (arr1.length !== arr2.length) {
          return false;
        }
        if (arr1.filter((item, idx) => item !== arr2[idx]).length) {
          return false;
        }
      }
      return true;
    }

    function filterProps(props) {
      return Object.keys(props).reduce((acc, key) => {
        if (
          [
            'onChange',
            'onSlide',
            'onUpdate',
            'range',
            'start',
            'defaultStart',
            'disabled'
          ].indexOf(key) === -1
        ) {
          acc[key] = props[key];
        }
        return acc;
      }, {});
    }

    if (!shallowEqual(filterProps(this.props), filterProps(nextProps))) {
      shouldUpdate = true;
    } else if (!shallowEqual(this.props.pips, nextProps.pips)) {
      shouldUpdate = true;
    } else if (
      !shallowEqual(this.props.range, nextProps.range) &&
      JSON.stringify(this.props.range) !== JSON.stringify(nextProps.range)
    ) {
      shouldUpdate = true;
    } else if (!arraysEqual(this.props.start, nextProps.start)) {
      shouldUpdate = true;
    }

    if (this.props.disabled !== nextProps.disabled) {
      if (nextProps.disabled) {
        this.sliderContainer.setAttribute('disabled', true);
      } else {
        this.sliderContainer.removeAttribute('disabled');
      }
    }

    if (shouldUpdate) {
      this.slider.destroy();
      this.createSlider(nextProps);
    }

    return false;
  }

  componentWillUnmount() {
    this.slider.destroy();
  }

  createSlider(nextProps) {
    const { start, defaultStart, disabled, ...props } = nextProps || this.props;

    const startValues = start || defaultStart;
    if (!startValues) {
      return null;
    }

    const slider = (this.slider = nouislider.create(this.sliderContainer, {
      ...props,
      start: startValues
    }));

    if (disabled) {
      this.sliderContainer.setAttribute('disabled', true);
    }

    slider.on('update', (...args) => {
      if (this.props.onUpdate) {
        this.props.onUpdate(...args);
      }
    });
    slider.on('change', (...args) => {
      if (this.props.onChange) {
        this.props.onChange(...args);
      }
    });
    slider.on('slide', (...args) => {
      if (this.props.onSlide) {
        this.props.onSlide(...args);
      }
    });

    if (nextProps && nextProps.onSlide) {
      nextProps.onSlide(startValues);
    }
  }

  render() {
    return (
      <div
        ref={element => {
          this.sliderContainer = element;
        }}
      />
    );
  }
}
